import axios from 'axios';
import Qs from 'qs';
import { Message, } from 'element-ui'; // 消息提示框组件

// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = '/api';
};

// 设置请求超时时间
axios.defaults.timeout = 10000;

// 设置post请求头
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';
// 请求拦截
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
  if (config.method === 'get') {
    //  给data赋值以绕过if判断
    config.data = true
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
}, error => {
  // 对请求错误做些什么
  Message.error(error)
  return Promise.error(error);
})

// 响应拦截
axios.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error);
});

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}



// WEBPACK FOOTER //
// ./src/ajax/request.js